<template>
  <div class="qrcode">
    <div class="code"><img src="../../assets/qrcode.png"/></div>
    <div class="textcon">
      <div class="codemessage">扫码关注大赛详情</div>
      <div class="swjs sw">商务合作</div>
      <div class="tel">021-23502953</div>
      <div class="swjs">技术支持</div>
      <div class="tel">0571-26691111</div>
      <!-- <div class="signup"><img @click="gosignup" src="../../assets/signup.png" /></div> -->
    </div>
    <singup></singup>
  </div>
</template>
<script>
import singup from "../common/singup.vue"
export default {
  components:{
    singup
  }
}
</script>
<style scoped>
  .qrcode {
    height: 100%;
    background: url("../../assets/commonbg.png") no-repeat center;
    background-size: cover;
    position: relative;
    text-align: center;
    font-size: 4vw;
  }

  .code {
    width: 49vw;
    margin: 0 auto;
    padding-top: 22vw;
  }

  .code img {
    width: 100%;
  }

  .textcon {
    margin-top: 2vw;
  }
  .codemessage {
    color: #86b6f8;
  }
  .swjs {
    color: #86D4F8;
    /* background-image: -webkit-linear-gradient(#fff, #4d6aff);
    background-image: -o-linear-gradient(#fff, #4d6aff);
    background-image: -moz-linear-gradient(#fff, #4d6aff);
    background-image: linear-gradient(#fff, #4d6aff);
    -webkit-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent; */
    margin-top: 5vw;
    margin-bottom: 2vw;
    font-weight: bold;
  }
  .sw {
    margin-top: 6vw;
  }
  .tel {
    color: #fff;
  }
  .signup {
    width: 51vw;
    margin: 0 auto;
    margin-top: 8vw;
  }
  .signup img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/qrcode.vue